import { easybackClient } from './api'
import { API_BASE } from './config'
import type { RegisterRequest } from '@/types/auth'

export const authService = {
  login: async (email: string, password: string) => {
    const result = await easybackClient.login(email, password)
    if(result.success)
    localStorage.setItem('token', result.data.token)
    return result.data
  },

  register: async (data: RegisterRequest) => {
    const result = await easybackClient.register(data.name, data.email, data.password, data.role, data.ref, data.adultConfirmed)
    if(result.success)
    localStorage.setItem('token', result.data.token)
    return result.data
  },

  logout: async () => {
    localStorage.removeItem('token')
    localStorage.removeItem('refresh_token')
  },

  forgotPassword: async (email: string) => {
    const response = await fetch(`${API_BASE}/auth/forgot-password`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email }),
    })
    const result = await response.json()
    if (!response.ok) {
      throw new Error(result.error?.message || 'Şifre sıfırlama başarısız')
    }
    return result.data
  },

  resetPassword: async (token: string, newPassword: string) => {
    const response = await fetch(`${API_BASE}/auth/reset-password`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token, newPassword }),
    })
    const result = await response.json()
    if (!response.ok) {
      throw new Error(result.error?.message || 'Şifre sıfırlama başarısız')
    }
    return result.data
  },

  verifyResetToken: async (token: string) => {
    const response = await fetch(`${API_BASE}/auth/verify-reset-token?token=${token}`)
    const result = await response.json()
    if (!response.ok) {
      throw new Error(result.error?.message || 'Token doğrulama başarısız')
    }
    return result.data
  },
}
